import config from '../../config';

let instance = null;

class StripeInstance {
  constructor() {
    instance = instance || window.Stripe.StripeV3(config.stripeKey);
    return instance;
  }
}

export default StripeInstance;



// WEBPACK FOOTER //
// ./src/app/utils/stripe.js